export const supportLinkLocales = ['us', 'ca', 'uk', 'au', 'de', 'fr', 'jp', 'za'];
